// @flow
import * as React from 'react';
import { Button, Input } from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';

type Props = {
  searchTerm: string,
  onChangeSearch: (e: any) => void,
  onSubmitSearch: () => void,
  onClickNewSupplier: () => void,
}

export default ({ searchTerm, onChangeSearch, onSubmitSearch, onClickNewSupplier }: Props) => (
  <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <div>
      <h1 style={{ margin: 0 }}>Suppliers</h1>
    </div>
    <div style={{ display: 'flex', gap: 8 }}>
      <Input.Search
        placeholder="Search suppliers..."
        value={searchTerm}
        onChange={onChangeSearch}
        onSearch={onSubmitSearch}
        style={{ width: 300 }}
        prefix={<SearchOutlined />}
      />
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={onClickNewSupplier}
      >
        New Supplier
      </Button>
    </div>
  </div>
);
